module.exports = __webpack_public_path__ + "static/media/become-title.f59c2453.png";